module.exports = __webpack_public_path__ + "img/cart.9a013a2f.svg";